module.exports = __webpack_public_path__ + "img/head.bdb32b4.png";